// Gets nonce from meta tag in document head which matches CSP nonce
// Used for inline scripts/styles
export const getNonce = (): string | undefined => {
  const meta = document.querySelector('meta[property="csp-nonce"]');
  return meta?.getAttribute('content') ?? (window as any).cspNonce;
};
